<template>
  <div class="hotSaleCourseBox" v-if="courseInfoData.length">
    <div class="hotSaleCourseWarrp">
      <div class="bg"></div>
      <div class="courseHead">
        <h2>专享轻学课</h2>
        <img
          class="courseHead_icon"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_course_good.png"
          alt
        />
        <div v-if="showMore" class="lookMore" @click="lookMoreList">
          进入专区
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotsalelookmore.png"
            alt
          />
        </div>
      </div>
      <ul class="hotSaleCourseMain">
        <div
          class="course_item"
          v-for="(item, keys) in courseInfoData"
          :key="keys"
          @click="goDateil(item)"
        >
          <div class="course_content">
            <div class="course_img_box">
              <img class="course_img_cover" :src="item.coverMobile" alt />
              <img
                class="course_img_icon"
                v-if="keys === 0 || keys === 1 || keys === 2"
                :src="`https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_coure_top${keys + 1}.png`"
                alt
              />
            </div>
            <div class="course_info">
              <div class="course_title">{{item.name}}</div>
              <div class="course_tags">
                <TagComponent
                  v-for="(tagItem, tagIndex) in tagType(item)"
                  :key="tagIndex"
                  :text="tagItem"
                  :color=" ['套餐','电子书'].includes(tagItem) ? 'blue' : 'yellow-no-bg'"
                />
              </div>
              <div class="course_time" v-if="item.startTime">上课时间 {{item.startTime.slice(0, 10)}}</div>
            </div>
          </div>
          <div class="course_bottom">
            <img
              class="course_bottom_icon"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_shop_icon.png"
              alt
            />
            <div class="course_bottom_num">{{item.salesVolume}}人已购买</div>

            <!-- 划线价 -->
            <del
              v-if="(item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) || item.promotionLabel"
              class="course_line_price"
            >￥{{item.originalPrice}}</del>

            <div class="course_price_box">
              <!-- 拼团价 -->
              <div
                class="course_price_tip"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >拼团价</div>

              <!-- 促销价 -->
              <div
                class="course_price_tip"
                v-else-if="item.promotionLabel"
              >{{item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'}}</div>

              <!-- 价格icon -->
              <div
                class="course_price_icon"
                v-if="(item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount) || !(item.sellPrice === 0 && !item.promotionLabel)"
              >￥</div>

              <!-- 价格 -->
              <div
                class="course_price_num"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >{{item.productDiscountRespVO.discountMinPrice}}</div>

              <!-- 免费 -->
              <div class="course_price_free" v-else>
                {{
                item.sellPrice === 0 && !item.promotionLabel ? '免费领取' : item.sellPrice
                }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="false" class="hotSaleName">
          <h3>{{item.name}}</h3>
          <span>{{item.brief}}</span>
          <div class="priceSaleBox">
            <div class="salesVolumeBox">{{ item.salesVolume }}人报名</div>
            <div class="coursePrice">
              <!-- <del v-if="item.originalPrice">￥{{ item.originalPrice }}</del> -->
              <span
                class="courseType"
                v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
              >拼团价</span>
              <span
                v-else-if="item.promotionLabel"
                class="courseType"
              >{{item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'}}</span>
              <p class="showPic">
                <template
                  v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
                >
                  <b>¥</b>
                  <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
                </template>
                <template v-else>
                  <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
                  <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">
                    {{
                    item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
                    }}
                  </span>
                </template>
              </p>
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>
<script>
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import { reqMajorAd, reqProducts } from '@/api/home';
import { deepCopy,gioPlatform } from '@/utils/tools';
import TagComponent from '@/components/commonComponents/TagComponent.vue';

// 广告曝光与广告点击
export default {
  components: {
    TagComponent,
  },
  data() {
    return {
      courseInfoData: [],
      showMore: true, // 是否显示查看更多
    };
  },
  props: {
    hotSaleId: Number,
    pageName: Number,
  },
  watch: {
    hotSaleId() {
      this.getCourseAd();
    },
  },
  mounted() {},
  methods: {
    tagType(val) {
      console.log('tagType', val);
      const type = [];
      if (val.isUnionDiscount) {
        type.push('联报优惠');
      }
      if (val.isSingleDiscount) {
        type.push('单减活动');
      }
      if (val.isCouponDiscount) {
        type.push('优惠券');
      }
      if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
        type.push('满减活动');
      }
      // 增加购课增好礼标签
      if (val.productDiscountRespVO && val.productDiscountRespVO.isBuyGiftGiveawaysDiscount) {
        type.push('购课赠好礼');
      }
      // 整改暂时注释分期
      /* if (val.huabeiStagingActivity) {
          type.push(`${val.huabeiStagingActivity.maxNumberOfPeriod}期分期免息`);
        } */
      if (val?.isEbook) {
        type.push('电子书');
      }
      if (val?.setType == 1) {
        type.push('套餐');
      }
      return type;
    },
    // 查看更多
    lookMoreList() {
      this.$router.push({
        path: '/hotSaleList',
        query: {
          recommendId: this.hotSaleId,
        },
      });
    },
    goDateil(item) {
      console.log(item, 'item');
      sessionStorage.setItem('back', 'true'); //此处是为了返回到上一页  不加会直接返回到官网首页了
      if (item.setType === 1) {
        // 套餐
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: item.packageId,
          },
        });
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: item.productId,
          },
        });
      }
      this.gioEvent(item);
    },
    // 查询广告位
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.hotSaleId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach(child => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then(result => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach(child => {
          const findRes = [...resCourse, ...resPackage].find(course => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse.length > 2 ? allCourse.slice(0, 2) : allCourse;
        this.showMore = allCourse.length > 2;
        if (!this.$root.$data.isApp) {
          // H5中储存数据
          sessionStorage.setItem('HOTSALELIST', JSON.stringify(allCourse));
        }
        // 广告曝光
        this.gioAdShown(this.courseInfoData);
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map(teacher => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach(item => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    gioEvent(courseInfoData) {
      const { name } = courseInfoData;
      // 点击广告
      // eslint-disable-next-line
      gio('track', 'adClick_event', {
        adPosition_var: `${this.pageName}考研-首页-热销课程`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var:
          courseInfoData?.setType === 1 ? courseInfoData.packageId : courseInfoData.productId,
        adName_var: name, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: courseInfoData?.setType === 1 ? '套餐' : '产品', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
    // 广告曝光gio
    gioAdShown(courseInfoData) {
      const jumpTypeList = [];
      const adNameList = [];
      const adIdList = [];
      // eslint-disable-next-line no-unused-expressions
      courseInfoData?.forEach(element => {
        // eslint-disable-next-line
        const jumpType = element?.setType === 1 ? '套餐' : '产品';
        const ids = element?.setType === 1 ? element.packageId : element.productId;
        jumpTypeList.push(jumpType);
        adNameList.push(element.name);
        adIdList.push(ids);
      });

      // eslint-disable-next-line no-undef
      gio('track', 'adShown_event', {
        adPosition_var: `${this.pageName}考研-首页-热销课程`, // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: adIdList.toString(), // 广告ID
        adName_var: adNameList.toString(), // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: jumpTypeList.toString(), // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.hotSaleCourseBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 18px;
  background: #f8f8f8;
  .hotSaleCourseWarrp {
    box-sizing: border-box;
    // background: linear-gradient(360deg, #ffffff 0%, #fcede6 100%);
    background: #ffffff;
    padding-bottom: 5px;
    .bg {
      width: 100%;
      height: 200px;
      // background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotsaleBg.png)
      // no-repeat;
      // background-size: 100% 100%;
      background: #ffffff;
    }
    .courseHead {
      width: 670px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: -168px;
      position: relative;

      h2 {
        font-size: 32px;
        font-weight: 500;
        color: #111111;
        line-height: 44px;
      }
      .courseHead_icon {
        position: absolute;
        height: 36px;
        width: 124px;
        left: 178px;
      }
      .lookMore {
        font-size: 20px;
        font-weight: 400;
        color: #999999;
        line-height: 28px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .hotSaleCourseMain {
      width: 670px;
      margin: 32px auto 0 auto;
      // padding: 0 24px;
      background: #fff;
      border-radius: 16px;
      li {
        display: flex;
        align-items: flex-start;
        border-bottom: 2px solid #f5f5f5;
        padding: 28px 0;
        &:nth-child(1) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotOne.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(2) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotTwo.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(3) .hotSalePic::before {
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotThree.png)
            no-repeat;
          background-size: 100% 100%;
        }
        &:last-child {
          border-bottom: none;
        }
        .hotSalePic {
          margin-right: 24px;
          position: relative;
          &::before {
            position: absolute;
            right: -1px;
            top: 0;
            content: '';
            width: 62px;
            height: 36px;
          }

          img {
            width: 180px;
            height: 130px;
            border-radius: 16px;
          }
        }
        .hotSaleName {
          width: 418px;
          > h3 {
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 36px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          > span {
            margin: 10px 0 14px 0;
            display: block;
            height: 36px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 36px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .priceSaleBox {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            .salesVolumeBox {
              font-size: 20px;
              font-weight: 400;
              color: #999999;
              line-height: 28px;
            }
            .coursePrice {
              display: flex;
              align-items: baseline;
              // del {
              //   color: #ff3938;
              //   font-size: 30px;
              // }
              .courseType {
                color: #ff3938;
                font-weight: 500;
                font-size: 20px;
              }
              .showPic {
                margin-left: 6px;
                font-weight: 400;
                font-size: 30px;
                text-align: center;
                b {
                  margin: 0 4px;
                  color: #ff3938;
                  font-size: 20px;
                }
                span {
                  color: #ff3938;
                  font-weight: 400;
                  font-size: 30px;
                }
                .fontSty {
                  font-size: 30px;
                }
              }
            }
          }
        }
      }
    }
  }

  .course_item {
    width: 678px;
    height: 239px;
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #f1d8b8;
    margin-bottom: 22px;
    overflow: hidden;

    .course_content {
      height: 173px;
      width: 100%;
      overflow: hidden;

      .course_img_box {
        float: left;
        position: relative;
        height: 136px;
        width: 188px;
        margin-top: 20px;
        margin-left: 18px;

        .course_img_cover {
          height: 100%;
          width: 100%;
          border-radius: 11px;
        }
        .course_img_icon {
          position: absolute;
          height: 29px;
          width: 94px;
          top: 0;
          right: 0;
        }
      }

      .course_info {
        float: left;
        width: 438px;
        margin-top: 29px;
        margin-left: 14px;

        .course_title {
          height: 33px;
          width: 438px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 25px;
          color: #333333;
          line-height: 33px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .course_tags {
          margin-top: 11px;
          height: 29px;
          display: flex;
          gap: 7px;

          .course_tag {
            // width: 69px;
            height: 29px;
            padding: 0 7px 0;
            background: #ff7f41;
            border-radius: 5px;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            line-height: 29px;
          }
        }

        .course_time {
          height: 25px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 25px;
          margin-top: 25px;
        }
      }
    }
    .course_bottom {
      position: relative;
      height: 64px;
      width: 100%;
      background: #fff9e9;
      border-radius: 0px 0px 14px 14px;
      border: 1px solid #f1d8b8;
      display: flex;
      align-items: center;

      .course_bottom_icon {
        display: block;
        height: 29px;
        width: 29px;
        margin-left: 18px;
      }
      .course_bottom_num {
        height: 31px;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        line-height: 31px;
        margin-left: 7px;
      }

      .course_line_price {
        position: absolute;
        top: 18px;
        right: 249px;
        height: 31px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        line-height: 31px;
      }

      .course_price_box {
        position: absolute;
        top: 0;
        right: 0;
        height: 65px;
        width: 243px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hot_price_bkg.png')
          no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;

        .course_price_tip {
          height: 25px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 33px;
        }

        .course_price_icon {
          height: 25px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 25px;
          color: #ffffff;
          line-height: 33px;
        }

        .course_price_num {
          height: 51px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 36px;
          color: #ffffff;
          line-height: 51px;
        }

        .course_price_free {
          height: 40px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 29px;
          color: #ffffff;
          line-height: 40px;
        }
      }
    }
  }
}
</style>
